"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const AccordionGroup_1 = __importDefault(require("./AccordionGroup"));
const AccordionItem_1 = __importDefault(require("./AccordionItem"));
const AccordionComponent = ({ border, children, className, expanded, heading, id, ...props }) => {
    return ((0, jsx_runtime_1.jsx)(AccordionGroup_1.default, { border: border, className: className, ...props, children: (0, jsx_runtime_1.jsx)(AccordionItem_1.default, { expanded: expanded, heading: heading, id: id, children: children }) }));
};
const Accordion = Object.assign(AccordionComponent, { Group: AccordionGroup_1.default, Item: AccordionItem_1.default });
exports.default = Accordion;
